import * as classNames from "classnames";
import * as React from "react";
import { MasteryTitle } from "source/app/presentation/Header/MasteryTitle/MasteryTitle";
import Data from "source/app/services/Data";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import Nameof from "source/app/services/NameOf";
import { State } from "source/app/services/UI/State/State";
import { ESharedComponent } from "../../services/UI/State/ESharedComponent";
import StatusBar from "../MainPanel/StatusBar/StatusBar";
import { sharedStylesOld } from "../Shared/Styles/SharedStyles";
import { HeaderCenter } from "./Center/HeaderCenter";
import * as styles from "./Header.css";
import LevelBadge from "./LevelBadge/LevelBadge";
import ProgressBar from "./ProgressBar/LevelProgressBar/LevelProgressBar";
import TodaysProgressBar from "./ProgressBar/TodaysProgressBar/TodaysProgressBar";
import Tools from "./Tools/Tools";

interface HeaderProps {
    level: number;
    diversityTarget: number;
    hidden?: boolean;
}

export interface IHeaderState {
    metDailyTarget: boolean;
    titleColor: string;
    lifetimeKipsEarned: number;
}

class Header extends React.PureComponent<HeaderProps, IHeaderState> {
    constructor(props: HeaderProps) {
        super(props);
        this.state = {
            metDailyTarget: false,
            titleColor: "white",
            lifetimeKipsEarned: 0,
        };
    }

    componentDidMount() {
        Data.Load.Component({
            component: this,
            load: MotwLogicServer.GetPlayerLifetimeKipsEarned,
            stateTarget: Nameof<IHeaderState>("lifetimeKipsEarned"),
            inLoadAll: true,
        });

        State.ShareClass(ESharedComponent.Header, this);
    }

    render() {
        return (
            <div
                className={classNames(
                    "navbar",
                    "navbar-fixed-top",
                    [styles.gradient],
                    [styles.container],
                    {
                        [styles.gradient_gold]: this.state.metDailyTarget,
                        [styles.gradient_normal]: !this.state.metDailyTarget,
                    }
                )}
                style={{
                    opacity: this.props.hidden ? 0 : 1,
                    pointerEvents: this.props.hidden ? "none" : "auto",
                    transition: "opacity 180ms ease",
                    willChange: "opacity",
                }}
            >
                <div id="pnlTitle" className="marginTopHalfem">
                    <div>
                        <h2
                            id="titleText"
                            className={classNames(
                                "inline",
                                "floatLeft",
                                [styles.titleText],
                                {
                                    [sharedStylesOld.metDailyTargetGlow]:
                                        this.state.metDailyTarget,
                                    [styles.notMetDailyTarget]:
                                        !this.state.metDailyTarget,
                                }
                            )}
                            style={{ color: this.state.titleColor }}
                        >
                            <MasteryTitle />
                        </h2>
                        <LevelBadge level={this.props.level} />
                        <Tools diversityTarget={this.props.diversityTarget} />
                    </div>
                    <ProgressBar />
                    <HeaderCenter />
                    <TodaysProgressBar />
                    <StatusBar />
                </div>
            </div>
        );
    }
}

export default Header;

export const SetTitleTextColor = (color: string) => {
    const header = State.ReadClass<IHeaderState>(ESharedComponent.Header);

    if (header) {
        header.setState({ titleColor: color });
    }
};
